










import { Vue, Component } from 'vue-property-decorator';
import InformesGenerados from '@/pantallas/Informes/InformesGenerados/InformesGenerados.vue';

@Component({
  components: { InformesGenerados },
})
export default class InformesGeneradosPantalla extends Vue {}
